.content {
  z-index: var(--z-popover);
  width: min(340px, calc(100vw - var(--space-6)));
  max-height: var(--radix-popover-content-available-height);
  overflow-y: auto;
  padding: var(--space-4);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-lg);
  outline: none;
  animation: appear var(--duration-fast) var(--ease-standard);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
}
